import {
  antdDrawerSheet,
  antdModalSheet,
  antdPopupSheet,
  customSheet,
  dataAttributeSheet,
  SheetSwipeSpec,
} from '@skygroup/shared/components/mobile-sheet-gestures';

// Phones: every bottom sheet in B2C closes with a swipe down (the shared
// recogniser, mounted once in App). Only sheets docked to the bottom edge at
// full width are picked up, so centred dialogs and side drawers are not.
//   • antd Modals shown as sheets (wrapClassName m-sheet / ge-m-sheet /
//     side-filters-sheet-wrap, action sheets from utils/mobileSheets.ts, the
//     must-watch video, live booking, baggage…) — via their close button or
//     their closable mask; required dialogs without either stay put;
//   • antd Drawers placement="bottom" (autocomplete, tree filter, departure,
//     agent, language, pax / infant, search sheets, video notifications,
//     guide steps…) — close button, mask or Esc;
//   • antd select / tree-select / cascader dropdowns shown as sheets
//     (components/MobileSelectSheet) — closed like a tap on their backdrop;
//   • custom sheets below, and anything marked up with data-sheet-swipe
//     (the bot chat panel).
export const B2C_SHEET_SWIPE_SPECS: SheetSwipeSpec[] = [
  antdModalSheet(),
  antdDrawerSheet(),
  // date / range pickers (useMobileDateSheet)
  customSheet({
    panel: '.ant-picker-dropdown.mobile-date-sheet',
    close: '.mobile-date-sheet__close',
  }),
  // header cart (Header.tsx — closeShoppingCart via its backdrop)
  customSheet({
    panel: '.mobile-cart-sheet #ShoppingCart',
    close: (panel) =>
      panel.closest('.mobile-cart-sheet')?.querySelector<HTMLElement>(
        ':scope > .mobile-cart-sheet__backdrop'
      ),
    backdrop: (panel) =>
      panel.closest('.mobile-cart-sheet')?.querySelector<HTMLElement>(
        ':scope > .mobile-cart-sheet__backdrop'
      ),
  }),
  // checkout / manage order summary (MobileOrderSummarySheetHeader)
  customSheet({
    panel: '.order-cart-body.is-sheet',
    close: '.order-summary-sheet__close',
    backdrop: (panel) =>
      panel.parentElement?.querySelector<HTMLElement>(
        ':scope > .order-summary-sheet-backdrop'
      ),
  }),
  // results pages: the full-screen search form sheet (SwitchDatePicker)
  customSheet({
    panel: [
      '.switch-date-picker-wrapper.is-search-sheet-open > .switch-date-picker',
      '.switch-date-picker-wrapper.is-search-sheet-open > .switch-date-picker1',
    ].join(','),
    close: '.mobile-search-sheet__close',
  }),
  // accessibility plugin toolbox (third-party; a sheet via
  // accessibilityPlugin.mobile.less) — through its own close link
  customSheet({
    panel: '#vplugin._vp_toolbox_visible #vplugin-interface',
    close: '#vp_close_toolbox',
  }),
  // select sheets (MobileSelectSheetLayer) — same scope as their styles
  antdPopupSheet(
    'body > div > div > .ant-select-dropdown:not(.m-no-sheet):not(.custom-auto-complete-dropdown):not(.guest-name-autocomplete-dropdown):not(.agent-sheet__search-popup):not(.additional-departure-dropdown-options)',
    {
      outside: () =>
        document.querySelector<HTMLElement>('.m-select-sheet-backdrop'),
    }
  ),
  dataAttributeSheet(),
];
